import { useActiveEsigningProvider } from 'app/domains/esigning/hooks/useActiveEsigningProvider';
import { sortAuthenticationModes } from './utils';
export function useEsigningAuthenticationModes() {
    const { provider } = useActiveEsigningProvider();
    const authModes = (provider === null || provider === void 0 ? void 0 : provider.authenticationModes) || [];
    const sortedAuthenticationModes = sortAuthenticationModes(authModes);
    return { authenticationModes: sortedAuthenticationModes };
}
